import { ReactComponentManifest } from "web/entrypoints/common/setup";
import { LystNewsIndex } from "web/react/pages/lyst-news/lyst-news-index";

export const lystNewsComponents: ReactComponentManifest = {
    LystNewsIndex,
};
